import React, { useState } from 'react';
import { Card, Checkbox, Col, Form, Input, Row } from 'antd';
import { inputSize } from '../../Shared/UI/jsx';

const { Item } = Form;
const { TextArea } = Input;

const Guardians = ({ form }) => {
    const [parentOneChecked, setParentOneChecked] = useState(false);
    const [parentTwoChecked, setParentTwoChecked] = useState(false);
    const [fosterParentChecked, setFosterParentChecked] = useState(false);
    const [guardianAdLitumChecked, setGuardianAdLitumChecked] = useState(false);
    const [guardianChecked, setGuardianChecked] = useState(false);

    const onParentOneChange = e => {
        const checked = e.target.checked
        setParentOneChecked(checked);
        console.log("Zipcode:", form.getFieldValue('zipcode'));
        if(checked) {
            form.setFieldsValue({
                parentOneAddress1: form.getFieldValue('address'),
                parentOneCity: form.getFieldValue('city'),
                parentOneZipcode: form.getFieldValue('zipcode')
            });
        } else {
            form.setFieldsValue({
                parentOneAddress1: '',
                parentOneCity: '',
                parentOneZipcode: '',
            });
        }
    };

    const onParentTwoChange = (e) => {
        const checked = e.target.checked;
        setParentTwoChecked(checked);

        if (checked) {
            form.setFieldsValue({
            parentTwoAddress1: form.getFieldValue('address'),
            parentTwoCity: form.getFieldValue('city'),
            parentTwoZipcode: form.getFieldValue('zipcode'),
            });
        } else {
            form.setFieldsValue({
            parentTwoAddress1: '',
            parentTwoCity: '',
            parentTwoZipcode: '',
            });
        }
    };

    const onFosterParentChange = (e) => {
        const checked = e.target.checked;
        setFosterParentChecked(checked);

        if (checked) {
            form.setFieldsValue({
            fosterParentAddress1: form.getFieldValue('address'),
            fosterParentCity: form.getFieldValue('city'),
            fosterParentZipcode: form.getFieldValue('zipcode'),
            });
        } else {
            form.setFieldsValue({
            fosterParentAddress1: '',
            fosterParentCity: '',
            fosterParentZipcode: '',
            });
        }
    };

    const onGuardianAdLitumChange = (e) => {
        const checked = e.target.checked;
        setGuardianAdLitumChecked(checked);

        if (checked) {
            form.setFieldsValue({
            guardianAdLitumAddress1: form.getFieldValue('address'),
            guardianAdLitumCity: form.getFieldValue('city'),
            guardianAdLitumZipcode: form.getFieldValue('zipcode'),
            });
        } else {
            form.setFieldsValue({
            guardianAdLitumAddress1: '',
            guardianAdLitumCity: '',
            guardianAdLitumZipcode: '',
            });
        }
    };

    const onGuardianChange = (e) => {
        const checked = e.target.checked;
        setGuardianChecked(checked);

        if (checked) {
            form.setFieldsValue({
            guardianAddress1: form.getFieldValue('address'),
            guardianCity: form.getFieldValue('city'),
            guardianZipcode: form.getFieldValue('zipcode'),
            });
        } else {
            form.setFieldsValue({
            guardianAddress1: '',
            guardianCity: '',
            guardianZipcode: '',
            });
        }
    };

    return (
        <Form
            form={form}
            size="small"
            layout="vertical"
        >
            <Row gutter={[8, 8]}>
                {/* Parent One  */}
                <Card title="Parent One" className='formCard'>
                    <Row>
                        <Col span={8}>
                            <Item name="parentOneFirstName1" label="First Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneFirstName2" label="First Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOnePreferredName" label="Preferred Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneLastName1" label="Last Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneLastName2" label="Last Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneLastNameHyphenated" valuePropName="checked">
                                <Checkbox>
                                    Last Name Hyphenated?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneEmail" label="Email">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneSameAsClient" valuePropName="checked">
                                <Checkbox checked={parentOneChecked} onChange={onParentOneChange}>
                                    Same Address as Client?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneAddress1" label="Address">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneAddress2" label="Address 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneCity" label="City">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneZipcode" label="Zipcode">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOnePhone" label="Phone">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentOneContact" valuePropName="checked">
                                <Checkbox>
                                    Contact Guardian
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={24}>
                            <Item name="parentOneNotes" label="Notes">
                                <TextArea className='textBox' />
                            </Item>
                        </Col>
                    </Row>
                </Card>
                {/* Parent Two  */}
                <Card title="Parent Two" className='formCard'>
                    <Row>
                        <Col span={8}>
                            <Item name="parentTwoFirstName1" label="First Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoFirstName2" label="First Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoPreferredName" label="Preferred Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoLastName1" label="Last Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoLastName2" label="Last Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoLastNameHyphenated" valuePropName="checked">
                                <Checkbox>
                                    Last Name Hyphenated?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoEmail" label="Email">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoSameAsClient" valuePropName="checked">
                                <Checkbox checked={parentTwoChecked} onChange={onParentTwoChange}>
                                    Same Address as Client?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoAddress1" label="Address">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoAddress2" label="Address 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoCity" label="City">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoZipcode" label="Zipcode">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoPhone" label="Phone">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="parentTwoContact" valuePropName="checked">
                                <Checkbox>
                                    Contact Guardian
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={24}>
                            <Item name="parentTwoNotes" label="Notes">
                                <TextArea className='textBox' />
                            </Item>
                        </Col>
                    </Row>
                </Card>
                {/* Foster Parent  */}
                <Card title="Foster Parent" className='formCard'>
                    <Row>

                        <Col span={8}>
                            <Item name="fosterParentFirstName1" label="First Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentFirstName2" label="First Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentPreferredName" label="Preferred Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentLastName1" label="Last Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentLastName2" label="Last Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentLastNameHyphenated" valuePropName="checked">
                                <Checkbox>
                                    Last Name Hyphenated?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentEmail" label="Email">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentSameAsClient" valuePropName="checked">
                                <Checkbox checked={fosterParentChecked} onChange={onFosterParentChange}>
                                    Same Address as Client?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentAddress1" label="Address">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentAddress2" label="Address 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentCity" label="City">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentZipcode" label="Zipcode">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterParentPhone" label="Phone">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="fosterContact" valuePropName="checked">
                                <Checkbox>
                                    Contact Guardian
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={24}>
                            <Item name="fosterParentNotes" label="Notes">
                                <TextArea className='textBox' />
                            </Item>
                        </Col>
                    </Row>
                </Card>
                {/* Guardian Ad Litum */}
                <Card title="Guardian Ad Litum" className='formCard'>
                    <Row>
                        <Col span={8}>
                            <Item name="guardianAdLitumParentFirstName1" label="First Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumFirstName2" label="First Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumPreferredName" label="Preferred Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumLastName1" label="Last Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumLastName2" label="Last Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumLastNameHyphenated" valuePropName="checked">
                                <Checkbox>
                                    Last Name Hyphenated?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumEmail" label="Email">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumSameAsClient" valuePropName="checked">
                                <Checkbox checked={guardianAdLitumChecked} onChange={onGuardianAdLitumChange}>
                                    Same Address as Client?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumAddress1" label="Address">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumAddress2" label="Address 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumCity" label="City">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumZipcode" label="Zipcode">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAdLitumPhone" label="Phone">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="adLitumContact" valuePropName="checked">
                                <Checkbox>
                                    Contact Guardian
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={24}>
                            <Item name="guardianAdLitumNotes" label="Notes">
                                <TextArea className='textBox' />
                            </Item>
                        </Col>
                    </Row>
                </Card>
                {/* Guardian */}
                <Card title="Guardian" className='formCard'>
                    <Row>
                        <Col span={8}>
                            <Item name="guardianFirstName1" label="First Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianFirstName2" label="First Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianPreferredName" label="Preferred Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianLastName1" label="Last Name">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianLastName2" label="Last Name 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianLastNameHyphenated" valuePropName="checked">
                                <Checkbox>
                                    Last Name Hyphenated?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianEmail" label="Email">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianSameAsClient" valuePropName="checked">
                                <Checkbox checked={guardianChecked} onChange={onGuardianChange}>
                                    Same Address as Client?
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAddress1" label="Address">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianAddress2" label="Address 2">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianCity" label="City">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianZipcode" label="Zipcode">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianPhone" label="Phone">
                                <Input style={inputSize} />
                            </Item>
                        </Col>
                        <Col span={8}>
                            <Item name="guardianContact" valuePropName="checked">
                                <Checkbox>
                                    Contact Guardian
                                </Checkbox>
                            </Item>
                        </Col>
                        <Col span={24}>
                            <Item name="guardianNotes" label="Notes">
                                <TextArea className='textBox' />
                            </Item>
                        </Col>
                    </Row>
                </Card>
            </Row>
        </Form>);
}

export default Guardians;